/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { LanguageHelp } from '../../../helpers/LanguageHelper'

type Props = {
  functionSubmit?: any
}


const Dropdown1: React.FC<Props> = ({functionSubmit }) => {
  const [date, setDate] = useState<string>('1')
  return (
    <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
      <div className='px-7 py-5'>
        <div className='fs-5 text-dark fw-bolder'>{LanguageHelp('Filter Options')}</div>
      </div>

      <div className='separator border-gray-200'></div>

      <div className='px-7 py-5'>
        <div className='mb-10'>
          <label className='form-label fw-bold'>{LanguageHelp('Date')}:</label>

          <div>
            <select
              className='form-select form-select-solid'
              defaultValue={'Last 30 days'}
              onChange={(e) => setDate(e.target.value)}
            >
              <option value={LanguageHelp('Today')}>{LanguageHelp('Today')}</option>
              <option value={LanguageHelp('Last 7 days')}>{LanguageHelp('Last 7 days')}</option>
              <option value={LanguageHelp('Last 30 days')}>{LanguageHelp('Last 30 days')}</option>
              <option value={LanguageHelp('Last 1 year')}>{LanguageHelp('Last 1 year')}</option>
              <option value={LanguageHelp('All time')}>{LanguageHelp('All time')}</option>
            </select>
          </div>
        </div>

        <div className='d-flex justify-content-end'>
          <button type='submit' onClick={async () => functionSubmit(date)} className='btn btn-sm btn-primary' data-kt-menu-dismiss='true'>
            Apply
          </button>
        </div>
      </div>
    </div>
  )
}

export { Dropdown1 }
